import { render } from "./BorderDrop.vue?vue&type=template&id=9977cb22"
import script from "./BorderDrop.vue?vue&type=script&lang=js"
export * from "./BorderDrop.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__